import { queryClient } from "@/App";
import type Feriado from "@/Models/geral/data/Feriado";
import { type EnumMes } from "@/Models/geral/data/Mes";
import Pagina, { type PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { Axios } from "@/Services/Axios";
import RequestUtilitario, { MutationBasicaParam, QueryBasicaParam } from "@/Utils/RequisicaoUtilitario";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

export function useFeriadoSalvar({
    onSuccess,
    ...rest
}:MutationBasicaParam<Feriado, AxiosResponse<number>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {
            return Axios.post<number>(`geral/data/feriado`, dataRequest);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Geral.Data.Feriado.Listar"] });
            onSuccess?.(retorno, entrada, context);
        }
    });
}

export function useFeriadoDesativar({
    onSuccess,
    ...rest
}:MutationBasicaParam<Feriado, AxiosResponse<void>>) {
    return useMutation({
        ...rest,
        mutationFn : (dataRequest) => {            
            return Axios.delete(`geral/data/feriado/${dataRequest.codigo}`);
        },
        onSuccess : (retorno, entrada, context) => {
            queryClient.invalidateQueries({ queryKey: ["Geral.Data.Feriado.Listar"] });
            queryClient.invalidateQueries({ queryKey: [`Geral.Data.Feriado.Buscar.${entrada.codigo}` ]});
            onSuccess?.(retorno, entrada, context);
        }
    });
}


export type FeriadoListarFiltros = {
    paginaInfo?:PaginaInfo,
    feriado?:Feriado,
    mes?: EnumMes;
};

export function useFeriadoListar({
    paginaInfo,
    feriado,
    mes,
    ...rest
}:QueryBasicaParam<AxiosResponse<Pagina<Feriado>>, Pagina<Feriado>, FeriadoListarFiltros>) {
    const queryString = RequestUtilitario.objectToQueryString({
        paginaInfo,
        feriado,
        mes,
    });

    return useQuery({
        ...rest,
        queryKey : [ "Geral.Data.Feriado.Listar", `Geral.Data.Feriado.Listar.Pagina?${queryString}` ],
        queryFn : () => Axios.get<Pagina<Feriado>>(`geral/data/feriado/pagina?${queryString}`),
        select(data) {
            data.data.registros.forEach(m => {
                m.dataCriacao = new Date(m.dataCriacao as any);
            });

            return data.data;
        },
        staleTime: 1000 * 60 * 0.25
    });
}